import { InputType } from "~/scad-shared/types/generic";

export type ControlTypeMappingType = Record<string, InputType>;

export const defaultControlTypeMapping: ControlTypeMappingType = {
  textarea: InputType.TextAreaInput,
  checkbox: InputType.BoolSelect,
  text: InputType.InputText,
  radio: InputType.RadioSelect,
  editor: InputType.RichText,
  multiselect: InputType.MultiSelect,
  time: InputType.TimeSelect,
  enumselect: InputType.EnumSelect,
  select: InputType.SelectDropdown,
  queryselect: InputType.SelectQuery,
  tableselect: InputType.SelectTable,
  textselect: InputType.SelectDropdown,
  fileuploadsingle: InputType.FileUpload,
  date: InputType.DateSelect,
  datetime: InputType.DateTimeSelect,
  number: InputType.NumberInput,
  integer: InputType.IntegerInput,
  percent: InputType.PercentageInput,
  currency: InputType.CurrencyInput,
  decimal: InputType.DecimalInput,
  picklist: InputType.PickList,
  daterange: InputType.DateRange,
  info: InputType.Info,
  year: InputType.YearSelect,
  month: InputType.MonthSelect,
  default: InputType.InputText,
};
